import Siema from "modules/siema";

import { Block } from "modules/Block";

import "./carousel-block.scss";

export class CarouselBlock extends Block<typeof CarouselBlock> {
    static readonly className = "js-carousel-block";

    private siema?: Siema;
    private prevButton?: HTMLElement | null;
    private nextButton?: HTMLElement | null;
    private pauseButton?: HTMLElement | null;
    private timerID?: ReturnType<typeof setInterval>;
    private timeToSlide: number = 5000;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        const siemaElement = rootElement.querySelector<HTMLElement>(".siema");

        if (siemaElement == null) {
            throw new Error("Siema element not found");
        }

        this.siema = new Siema({
            loop: true,
            duration: 200,
            selector: siemaElement,
            onChange: this.handleChangeSlide,
        });

        const timeToSlide = Number(siemaElement.dataset.slide);

        if (!isNaN(timeToSlide) && timeToSlide > 0) {
            this.timeToSlide = timeToSlide;
        }
    
        this.timerID = setInterval(this.handleIntervalTick, this.timeToSlide);

        const controlsContainer = siemaElement.nextElementSibling;

        this.prevButton = controlsContainer?.querySelector<HTMLElement>(".carousel__prev");
        this.nextButton = controlsContainer?.querySelector<HTMLElement>(".carousel__next");
        this.pauseButton = controlsContainer?.querySelector<HTMLElement>(".carousel__pause");

        this.prevButton?.addEventListener("click", this.handlePrevClick);
        this.nextButton?.addEventListener("click", this.handleNextClick);
        this.pauseButton?.addEventListener("click", this.handlePauseClick);
    }

    handleIntervalTick = () => {
        this.siema?.next();
    }

    handlePrevClick = () => {
        this.siema?.prev();
    }

    handleNextClick = () => {
        this.siema?.next();
    }

    handlePauseClick = (e: MouseEvent) => {
        if (!e.target || !(e.target instanceof Element)) return;

        e.target.classList.toggle("is-paused");

        if (e.target.classList.contains("is-paused")) {
            clearInterval(this.timerID);
        } else {
            this.timerID = setInterval(this.handleIntervalTick, this.timeToSlide);
        }
    }

    handleChangeSlide(this: Siema) {
        const indicatorContainer = this.rootElement.nextElementSibling;
        const indicators = indicatorContainer?.querySelectorAll(
            ".slide__indicator"
        );

        indicators?.forEach((indicator) => {
            if (this.currentSlide == parseInt(indicator.getAttribute("data-index") || "-1")) {
                indicator.classList.add("active");
            } else {
                indicator.classList.remove("active");
            }
        });
    }

    destroy(): void {
        this.siema?.destroy();
        clearInterval(this.timerID);
        this.prevButton?.removeEventListener("click", this.handlePrevClick);
        this.nextButton?.removeEventListener("click", this.handleNextClick);
        this.pauseButton?.removeEventListener("click", this.handlePauseClick);
    }
}